var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"moneyx morph",class:_vm.customClass},[_vm._v("\n    "+_vm._s(_vm.display)+" \n")])
}
var staticRenderFns = []

export { render, staticRenderFns }